import { CSPUrlsMap } from '../../routes/CSPUrlsMap';

export const PINSCOMCSPConfig = {
  cspConfiguration: {
    partner: 'pinscom',
    partnerTitle: 'Petinsurance.com.au Pet Insurance',
    auth0Config: {
      sit: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'pinscom-sit-petportal-auth.petsure.com.au',
        appClientId: 'MNXhDXBRhdcweRdSsrbGJmuc7nWA5Hl1',
        cspMfaUrl: 'https://pinscom-sit2-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-pinscom-sys.petsure.com.au/account-verification'
      },
      uat: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'pinscom-uat-petportal-auth.petsure.com.au',
        appClientId: 'j4zhnoN2rc5x8wUytrNjPaCHyZUIafhL',
        cspMfaUrl: 'https://pinscom-uat-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-pinscom-uat.petsure.com.au/account-verification'
      },
      preprod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'petportal-preprod-auth.petinsurance.com.au',
        appClientId: 'wTX5kQnkh2k0ek0lXmxcV2Aoqm6Eaz4j',
        cspMfaUrl: 'https://pinscom-preprod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-preprod.petinsurance.com.au/account-verification'
      },
      prod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'petportal-auth.petinsurance.com.au',
        appClientId: 'PGE5XXVYL3CRod48yZHlDVEhhKogcQ7Q',
        defaultAudience: 'https://cspmiddlewareapi',
        cspMfaUrl: 'https://pinscom-prod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal.petinsurance.com.au/account-verification'
      }
    },
    liveVetConfig: {
      sit: {
        vetChatAppModule: 'petinsurance.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      uat: {
        vetChatAppModule: 'petinsurance.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      preprod: {
        vetChatAppModule: 'petinsurance.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      prod: {
        vetChatAppModule: 'petinsurance.vetchat.com.au',
        vetChatUrl: 'https://livevet.vetchat.com.au',
        vetChatConsultationUrl: 'https://livevet.vetchat.com.au/consult'
      }
    },
    creditCardConfig: {
      sit: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      uat: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      preprod: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      prod: {
        formUrl: 'https://quickweb.westpac.com.au/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      paynowSupplierBusinessCode: 'RTCC',
      paynowSupplierBusinessCodePetsure: 'RTCC_PS'
    },
    bannerImage: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/bg/bg-pinscom.png',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/bg/bg-pinscom.png'
    },
    customFaviconUrl: {
      nonprod:
        'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/favicon/pinscom-favicon.png',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/favicon/pinscom-favicon.png'
    },
    headerLogo: {
      nonprod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/logo/pinscom-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/logo/pinscom-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      }
    },
    footerLogo: {
      nonprod: {
        imageUrl:
          'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/footer/pinscom-footer.png',
        imageTitle: 'Petinsurance.com.au Pet Insurance',
        imageTitleDescription: 'Petinsurance.com.au Pet Insurance'
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/footer/pinscom-footer.png',
        imageTitle: 'Petinsurance.com.au Pet Insurance',
        imageTitleDescription: 'Petinsurance.com.au Pet Insurance'
      }
    },
    termsOfUseUrl:
      'https://petcdnstore.blob.core.windows.net/csp-common/pdfs/terms_of_use/Customer_Portal_Terms_of_Use_092024.pdf',
    header: {
      layoutConfig: {
        small: 'hamburger',
        large: 'horizontal'
      }
    },
    faqRedirection: {
      excessTooltip: {
        category: 'claims',
        question: 'How is my claim benefit calculated?'
      },
      editName: {
        category: 'policy management',
        question: `Why can't I edit my name in the Pet Portal?`
      },
      addYourVet: {
        category: 'getting started',
        question: 'Adding your vet to your account'
      }
    },
    isLiteModeEnabled: false,
    isLecBrand: true,
    gtm: {
      id: 'GTM-56PVBTDH',
      dataLayer: 'dataLayer'
    },
    seo: {
      title: 'Petinsurance.com.au Pet Insurance - Pet Portal Login',
      description:
        'Access your Petinsurance.com.au Pet Portal to manage your pet policy, access 24/7 Live Vet support and to submit and track your claims.'
    }
  }
};
